
{% block sw_cms_element_dvsn_form_builder_config %}
    <div class="sw-cms-el-config-dvsn-form-builder">
        <mt-banner variant="info">
            {{ $t('dvsn-form-builder.cms-element.config.alert') }}
        </mt-banner>

        <sw-entity-single-select
            :helpText="$t('dvsn-form-builder.cms-element.form.help-text')"
            :label="$t('dvsn-form-builder.cms-element.form.label')"
            :placeholder="$t('dvsn-form-builder.cms-element.form.placeholder')"
            entity="dvsn_form_builder_form"
            v-model:value="element.config.form.value"
        />
    </div>
{% endblock %}
